"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var shared_1 = require("mad-utils/lib/shared");
/**************************************** PROJECT MODULES *****************************************/
var sql_query_parser_1 = require("../../util/sql-query-parser");
/********************************************* CONFIG *********************************************/
// Javelin object ID keys. If any one of these is given to query as the key to perform a
// check on, also examine the current object at key 'id' (Deals with a Kotlin edge case)
var idTypes = ['conceptId', 'generatorId', 'recordId', 'doseId'];
/**
 * Implementation of queryData method (see above for descriptions)
 *
 * parsedQuery returns object in format akin to this (pseudocode):
 *     {
 *         SelectStatement: {
 *             dataType: Record
 *         },
 *         WhereStatements: [
 *             {key: "name", value: 'Meeka'},
 *             {key: "id", value: 123},
 *         ]
 *     }
 */
function queryData(type, query, getModelData) {
    var parsedQuery = sql_query_parser_1.parseSqlQueryString(typeof query === 'string' ? query : query.build());
    var data;
    var modelName;
    // Get model data corresponding to the type
    for (var _i = 0, _a = parsedQuery.query; _i < _a.length; _i++) {
        var node = _a[_i];
        if (node.type === 'SelectStatement') {
            modelName = node.model;
            data = getModelData(modelName);
            break;
        }
    }
    // If no data retrieved at this point, return early (for performance)
    var isNoData = typeof data === 'undefined' || data === null;
    if ((isNoData || data.length === 0) && type === 'list')
        return [];
    if (isNoData && type === 'single')
        return null;
    // Filtering by WHERE clauses
    for (var _b = 0, _c = parsedQuery.query; _b < _c.length; _b++) {
        var node = _c[_b];
        if (node.type === 'WhereStatement') {
            (node.children || node.whereClauses).forEach(function (whereNode) {
                // Handle where clauses in form  ::  WHERE key = "value"
                if (whereNode.operation === 'equal') {
                    // Return data matching where clause e.g. objects where "name = 'meeka'"
                    data = filterJvlnDataObjects(data, whereNode.dataProp, whereNode.value);
                }
            });
        }
    }
    // Handle return value based on requested data type
    return type === 'list' ? buildQueryReturn('list', data) : buildQueryReturn('single', data);
}
exports.queryData = queryData;
/**************************************** PRIVATE HELPERS *****************************************/
/**
 * Return all matching Javelin objects based on the key & value. Keeps objects where either:
 *   1) 1 of special keys isActive or active are present & mapped to 'true' or true
 *   2) key is an ID of some type, and data.id equals the given value
 *   3) data at given key matches given value (object[key] === value)
 *
 * Check should be generated by a where clause string: e.g. "WHERE age = 33")
 *
 * @param {Array<T>} data Array of data objects to filter
 * @param {string} key Key to check for each object in data array
 * @param {any} value Return objects where the value at 'key' matches this
 *
 * @return {Array<T>} Array of all matching data objects
 */
function filterJvlnDataObjects(data, key, value) {
    return data.filter(function (dataObj) {
        // SPECIAL CASE: match if key is active/isActive, and value is true/"true",
        if (key === 'active' && shared_1.isTrue(value))
            return dataObj['isActive'] === true;
        // SPECIAL CASE: match if 1) key indicates it's an ID of any type; and
        //                        2) data at object's 'id' key is the expected value
        if (!dataObj[key] && idTypes.some(function (id) { return key === id; }) && dataObj['id']) {
            return dataObj['id'] === value;
        }
        // If both special conditions passed: match if data at key matches expected value
        return dataObj[key] === value;
    });
}
function buildQueryReturn(type, data) {
    // Returns 1st matching item, or null if type is 'single'
    if (type === 'single') {
        if (Array.isArray(data) && data.length > 0) {
            return data[0];
        }
        else if (Array.isArray(data) && data.length <= 0) {
            return null;
        }
        else {
            return data;
        }
    }
    // Returns all matching items (if type is 'list')
    if (type === 'list')
        return data;
}
//# sourceMappingURL=javelin-data-util.js.map